import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  Output,
  Attribute,
  ContentChild,
  ViewChild,
  EventEmitter,
  TemplateRef,
  ElementRef
} from '@angular/core';

@Component({
  selector: 'ts-listbox',
  templateUrl: './listbox.component.html',
  imports: [CommonModule]
})
export class ListboxComponent<TData> {
  @Input() options: TData[] = [];
  @Input() selectedOption: TData | undefined = undefined;
  @Input() maxHeight: 100 | 90 | 75 | 60 | 50 | 40 | 30 | 25 | 20 | 15 | 10 | undefined = undefined;
  @Output() selectionEvent: EventEmitter<TData> = new EventEmitter<TData>();
  @ViewChild('listbox') listboxRef: ElementRef | null = null;
  @ContentChild('listboxOption') optionTemplate: TemplateRef<any> | null = null;

  constructor(
    @Attribute('aria-label') public ariaLabel: string | null = null,
    @Attribute('aria-labelledby') public ariaLabelledBy: string | null = null,
    @Attribute('aria-describedby') public ariaDescribedBy: string | null = null,
    @Attribute('class') public listboxClassName: string | null = null
  ) {}

  optionLabel(option: any): string {
    if (Object(option) !== option) return String(option);
    return option?.label ?? option?.name ?? option?.title ?? option?.toString() ?? '';
  }

  listboxClassAttr():
    | string
    | string[]
    | Set<string>
    | { [klass: string]: any }
    | null
    | undefined {
    const classes = ['list-group'];
    if (this.listboxClassName) {
      classes.push(this.listboxClassName);
    }
    return classes;
  }

  onOptionKeyDown(event: KeyboardEvent, option: TData) {
    const optionElt = <HTMLElement>event.currentTarget;

    switch (event.key) {
      case 'ArrowDown':
        const nextOption = optionElt.nextElementSibling as HTMLElement;
        if (nextOption) nextOption.focus();
        event.preventDefault();
        break;
      case 'ArrowUp':
        const previousOption = optionElt.previousElementSibling as HTMLElement;
        if (previousOption) previousOption.focus();
        event.preventDefault();
        break;
      case 'Home':
        const firstOption = this.listboxRef?.nativeElement.firstElementChild as HTMLElement;
        if (firstOption) firstOption.focus();
        event.preventDefault();
        break;
      case 'End':
        const lastOption = this.listboxRef?.nativeElement.lastElementChild as HTMLElement;
        if (lastOption) lastOption.focus();
        event.preventDefault();
        break;
      case 'Enter':
        this.selectOption(option);
        event.preventDefault();
        break;
      case ' ':
        break;
    }
  }

  selectOption(option: TData): void {
    this.selectedOption = option;
    this.selectionEvent.emit(option);
  }
}
